import { Sparkles } from 'lucide-react';

const AIMorningSummary = ({ text, app = 'lumina' }) => {
  const iconColors = {
    lumina: '#6b5ce7',
    revq: '#10b981',
    echo: '#3b82f6',
  };

  return (
    <div
      style={{
        background: '#111111',
        borderRadius: 10,
        padding: '16px 20px',
        border: '0.5px solid #2a2a2a',
        marginBottom: 20,
      }}
      data-testid={`ai-morning-summary-${app}`}
    >
      <div className="flex items-start gap-3">
        <Sparkles
          className="flex-shrink-0 mt-0.5"
          style={{ width: 14, height: 14, color: iconColors[app] || '#6b5ce7' }}
        />
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.85)', lineHeight: 1.6, margin: 0, fontWeight: 400 }}>
          {text}
        </p>
      </div>
    </div>
  );
};

export default AIMorningSummary;
